/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-07-29T14:37:11.983
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveReportFinancialOutsideStorageContract,
	getReportFinancialOutsideStorageContractCreateInit,
	getReportFinancialOutsideStorageContractEditInit,
	getReportFinancialOutsideStorageContractView,
	deleteReportFinancialOutsideStorageContract
} from '@api/report/ReportFinancialOutsideStorageContract';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getReportFinancialOutsideStorageContractCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getReportFinancialOutsideStorageContractCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getReportFinancialOutsideStorageContractEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportFinancialOutsideStorageContractEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveReportFinancialOutsideStorageContract({}, ReportFinancialOutsideStorageContract) {
			return new Promise((resolve, reject) => {
				saveReportFinancialOutsideStorageContract(ReportFinancialOutsideStorageContract)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getReportFinancialOutsideStorageContractView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportFinancialOutsideStorageContractView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteReportFinancialOutsideStorageContract({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportFinancialOutsideStorageContract({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
